import { SchoolAggregationType } from 'enums';
import { capitalize } from 'utils';

type DinamicBrandLabel =
  | 'marcas'
  | 'marca'
  | 'prefeituras'
  | 'prefeitura'
  | 'regionais'
  | 'regional'
  | 'Marcas'
  | 'Marca'
  | 'Prefeituras'
  | 'Prefeitura'
  | 'Regionais'
  | 'Regional';

/**
 * Usado na construção das tabelas para traduzir dinamicamente a coluna se
 * for 'marca' ou 'marcas' dependendo do tipo de agregação do evento.
 * @param aggregationType BRAND | REGIONAL | PREFECTURE
 * @param columnLabel string
 * @param isCapitalize boolean
 * @return DinamicBrandLabel
 */
const getName = (
  aggregationType: SchoolAggregationType | undefined,
  columnLabel: string,
  isCapitalize = false,
): DinamicBrandLabel | string => {
  const label = columnLabel.trim().toLowerCase();

  if (label === 'marcas') {
    return getAggregationTypeLabel(aggregationType, isCapitalize, false);
  }
  if (label === 'marca') {
    return getAggregationTypeLabel(aggregationType, isCapitalize, true);
  }

  return columnLabel;
};

/**
 * Função usada para construir a label correta da marca que pode ser diferente para cada evento
 * (marca(s) | regional(is) | prefeitura(s))
 * @param isCapitalize boolean
 * @param isSingular boolean
 * @return string
 */
const getAggregationTypeLabel = (
  aggregationType: SchoolAggregationType | undefined,
  isCapitalize = false,
  isSingular = true,
): string => {
  const aggregationLabel = {
    [SchoolAggregationType.BRAND]: isSingular ? 'marca' : 'marcas',
    [SchoolAggregationType.REGIONAL]: isSingular ? 'regional' : 'regionais',
    [SchoolAggregationType.PREFECTURE]: isSingular
      ? 'prefeitura'
      : 'prefeituras',
  };

  const labelValue = aggregationType ? aggregationLabel[aggregationType] : '';

  return isCapitalize ? capitalize(labelValue) : labelValue;
};

export { getAggregationTypeLabel, getName };
